import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
  CardElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Snackbar,
  Alert
} from '@mui/material';

const stripePromise = loadStripe('pk_test_51RC6n8PQDmIXMi0KElnQsFVtPZ7CDbSmH6fyl5S3QH9oW6Uf9ns671xrX45MUvQvbECnFCEPCrsUeayiNKM8qK5700bpSrTgxX');

const CheckoutForm = ({ amountEUR, onSuccess, onError }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handlePayment = async () => {
    setLoading(true);

    if (!stripe || !elements) return;

    try {
      const res = await fetch('/create-payment-intent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: amountEUR })
      });

      const { clientSecret } = await res.json();

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement)
        }
      });

      if (result.error) {
        onError(result.error.message);
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          onSuccess();
          setOpenSnackbar(true);
        }
      }
    } catch (err) {
      onError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: 2,
          mb: 2
        }}
      >
        <CardElement options={{ hidePostalCode: true }} />
      </Box>
      <Button
        onClick={handlePayment}
        variant="contained"
        disabled={!stripe || loading}
        sx={{ px: 4 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Плати'}
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          Успешно плаќање! Сега можеш да го објавиш огласот.
        </Alert>
      </Snackbar>
    </Box>
  );
};

const StripePayment = ({ amountMKD, onPaymentSuccess, onPaymentError }) => {
  const amountEUR = Math.ceil(amountMKD / 61.5); // конверзија MKD -> EUR

  return (
    <Elements stripe={stripePromise}>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Вкупно за плаќање: {amountMKD} денари (~{amountEUR} €)
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Откако ќе го завршите плаќањето, кликнете на копчето „Објави оглас“.
      </Typography>
      <CheckoutForm
        amountEUR={amountEUR}
        onSuccess={onPaymentSuccess}
        onError={onPaymentError}
      />
    </Elements>
  );
};

export default StripePayment;
